var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-grid',{ref:"vxeGrid",attrs:{"size":"small","border":"","resizable":"","auto-resize":"","highlight-hover-row":"","data":_vm.tableData,"columns":_vm.tableColumns,"header-cell-style":function () {
      return {
        backgroundColor: '#bd94c1',
        color: '#ffffff',
      }
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }